import { useState } from 'react';

const STORAGE_KEY = 'coach_selected_contact_id';

function useSelectedCoach(defaultContactId: number, isSuper: boolean) {
    const stored = isSuper ? Number(sessionStorage.getItem(STORAGE_KEY)) || null : null;
    const initial = stored ?? defaultContactId;
    const [activeContactId, setActiveContactId] = useState<number>(initial);

    const setCoach = (id: number) => {
        sessionStorage.setItem(STORAGE_KEY, String(id));
        setActiveContactId(id);
    };

    return { activeContactId, setCoach, isSelected: stored !== null };
}

export default useSelectedCoach;
